// Interaction events for pages whose meaning is lost in page_view alone.
// The Lab wall is the first: one route holds a spatial view, a flat index and
// 29 records, so "someone opened /lab/" says nothing about what they did there.
//
// Silence is the default. src/main.js installs GA4 only on the production apex
// and www hosts; this helper refuses to send unless that installation actually
// happened, which keeps dev, preview, prerender and every other host quiet
// without each call site repeating the check.
//
// Only public catalog facts may be passed in. Route queries, referrers, form
// input and anything a visitor typed stay out — the same rule
// scripts/test-analytics-contract.cjs enforces on page_location.

const VALUE_LIMIT = 100

// Any *_url parameter keeps origin + pathname only. A source link can carry
// tracking or session query strings that are none of our business.
const withoutQuery = value => {
  try {
    const url = new URL(String(value), 'https://cheyuwu.com/')
    return url.origin + url.pathname
  } catch {
    return ''
  }
}

export const cleanEventParams = params => {
  const cleaned = {}
  for (const [key, value] of Object.entries(params || {})) {
    if (value === undefined || value === null || value === '') continue
    if (typeof value === 'number' || typeof value === 'boolean') {
      cleaned[key] = value
      continue
    }
    const text = key.endsWith('_url') ? withoutQuery(value) : String(value)
    if (text) cleaned[key] = text.slice(0, VALUE_LIMIT)
  }
  return cleaned
}

// Returns whether the event was sent, so tests can assert on the silent path.
export const trackEvent = (name, params) => {
  if (typeof window === 'undefined') return false
  if (!window.__cheyuAnalyticsInitialized) return false
  if (typeof window.gtag !== 'function') return false
  window.gtag('event', name, cleanEventParams(params))
  return true
}
